import type { ReactNode } from "react";

import { tw } from "@/utils";
import { Header } from "./Header";

interface NewIntakeLayoutProps {
  children: ReactNode;
  isEdgeCaseScreen?: boolean;
  isEndScreen?: boolean;
}

export const NewIntakeLayout = ({
  children,
  isEdgeCaseScreen = false,
  isEndScreen = false,
}: NewIntakeLayoutProps) => {
  return (
    <div
      className={tw(
        "flex h-screen flex-col overflow-hidden bg-background",
        isEdgeCaseScreen || isEndScreen ? "" : "gap-y-10",
      )}
    >
      <Header />
      <main
        className={tw(
          "h-full grow overflow-y-auto",
          isEndScreen ? "" : "px-16",
        )}
      >
        {children}
      </main>
    </div>
  );
};
